import { Locale } from 'chaika-enums';
export const laboratoryModule = {
    nomenclatureReport: {
        [Locale.Ru]: 'Отчет по проданной номенклатуре',
        [Locale.Am]: 'Վաճառված անվանացանկի հաշվետվություն',
        [Locale.En]: 'Report on sold items',
        [Locale.Pt]: 'Relatório sobre itens vendidos',
        [Locale.Ge]: 'Report on sold items',
    },
    salesReport: {
        [Locale.Ru]: 'Отчет по продажам',
        [Locale.Am]: 'Վաճառքների հաշվետվություն',
        [Locale.En]: 'Sales report',
        [Locale.Pt]: 'Relatório de vendas',
        [Locale.Ge]: 'Sales report',
    },
    movingReport: {
        [Locale.Ru]: 'Отчет лист движения',
        [Locale.Am]: 'Շարժի թերթիկի հաշվետվություն',
        [Locale.En]: 'Report sheet movement',
        [Locale.Pt]: 'Movimentação da planilha de relatório',
        [Locale.Ge]: 'Report sheet movement',
    },
    addLab: {
        [Locale.Ru]: 'Добавить лабораторию',
        [Locale.Am]: 'Ավելացնել լաբորատորիա',
        [Locale.En]: 'Add a lab',
        [Locale.Pt]: 'Adicionar um laboratório',
        [Locale.Ge]: 'Add a lab',
    },
    changeOfLab: {
        [Locale.Ru]: `Изменение лаборатории`,
        [Locale.Am]: `Լաբորատորիայի փոփոխում`,
        [Locale.En]: `Change of laboratory`,
        [Locale.Pt]: 'Mudança de laboratório',
        [Locale.Ge]: `Change of laboratory`,
    },
    addingLab: {
        [Locale.Ru]: `Добавление лаборатории`,
        [Locale.Am]: `Լաբորատորիայի ավելացում`,
        [Locale.En]: `Adding a Lab`,
        [Locale.Pt]: 'Adicionando um laboratório',
        [Locale.Ge]: `Adding a Lab`,
    },
    labUserAutoText: {
        [Locale.Ru]: `Пользователь для лаборатории будет создан автоматически`,
        [Locale.Am]: `Լաբորատորիայի համար օգտատերը կստեղծվի ավտոմատ`,
        [Locale.En]: `A user for the lab will be created automatically.`,
        [Locale.Pt]: 'Um usuário para o laboratório será criado automaticamente.',
        [Locale.Ge]: `A user for the lab will be created automatically.`,
    },
    integrationType: {
        [Locale.Ru]: `Тип интеграции`,
        [Locale.Am]: `Ինտեգրացիայի տեսակ`,
        [Locale.En]: `Integration type`,
        [Locale.Pt]: 'Tipo de integração',
        [Locale.Ge]: `Integration type`,
    },
    labId: {
        [Locale.Ru]: `ID лаборатории`,
        [Locale.Am]: `Լաբորատորիայի ID`,
        [Locale.En]: `Lab ID`,
        [Locale.Pt]: 'ID do laboratório',
        [Locale.Ge]: `Lab ID`,
    },
    labIdFromAstraLab: {
        [Locale.Ru]: `ID лаборатории из AstraLab`,
        [Locale.Am]: `Լաբորատորիայի ID AstraLab-ից`,
        [Locale.En]: `Lab ID from AstraLab`,
        [Locale.Pt]: 'ID do laboratório do AstraLab',
        [Locale.Ge]: `Lab ID from AstraLab`,
    },
    labName: {
        [Locale.Ru]: `Название лаборатории`,
        [Locale.Am]: `Լաբորատորիայի անվանում`,
        [Locale.En]: `Name of the laboratory`,
        [Locale.Pt]: 'Nome do laboratório',
        [Locale.Ge]: `Name of the laboratory`,
    },
    hasIntegration: {
        [Locale.Ru]: `Наличие интеграции`,
        [Locale.Am]: `ինտեգրման առկայություն`,
        [Locale.En]: `Has integration`,
        [Locale.Pt]: 'Possui integração',
        [Locale.Ge]: `ინტეგრაციის არსებობა`,
    },
    labEmail: {
        [Locale.Ru]: `Email лаборатории`,
        [Locale.Am]: `Լաբորատորիայի էլ. հասցե`,
        [Locale.En]: `Laboratory email`,
        [Locale.Pt]: 'E-mail do laboratório',
        [Locale.Ge]: `Laboratory email`,
    },
    bioAndLocal: {
        [Locale.Ru]: `Биомат/Локал`,
        [Locale.Am]: `Կենսանյութ/Լոկալ`,
        [Locale.En]: `Biomat/Local`,
        [Locale.Pt]: 'Bioma/Local',
        [Locale.Ge]: `Biomat/Local`,
    },
    biomaterialAndLocal: {
        [Locale.Ru]: `Биоматериал / Локал`,
        [Locale.Am]: `Կենսանյութ / Լոկալ`,
        [Locale.En]: `Biomaterial / Local`,
        [Locale.Pt]: 'Biomaterial / Local',
        [Locale.Ge]: `Biomaterial / Local`,
    },
    biomaterialAndLocalization: {
        [Locale.Ru]: `Биоматериал / Локализация`,
        [Locale.Am]: `Կենսանյութ / Տեղակայում`,
        [Locale.En]: 'Biomaterial / Localization',
        [Locale.Pt]: `Biomaterial / Localização`,
        [Locale.Ge]: `Biomaterial / Localization`,
    },
    preanalytics: {
        [Locale.Ru]: `Преаналитика`,
        [Locale.Am]: `Նախաանալիտիկա`,
        [Locale.En]: 'Preanalytics',
        [Locale.Pt]: `Pré-analítica`,
        [Locale.Ge]: `Preanalytics`,
    },
    referralAuthor: {
        [Locale.Ru]: `Автор направления`,
        [Locale.Am]: `Ուղեգրի հեղինակ`,
        [Locale.En]: `Author of the referral`,
        [Locale.Pt]: 'Autor da referência',
        [Locale.Ge]: `Author of the referral`,
    },
    renderedServiceAuthor: {
        [Locale.Ru]: `Автор оказанной услуги`,
        [Locale.Am]: `Մատուցված ծառայության հեղինակ`,
        [Locale.En]: `Author of the rendered service`,
        [Locale.Pt]: 'Autor do serviço prestado',
        [Locale.Ge]: `Author of the rendered service`,
    },
    maxReadiness: {
        [Locale.Ru]: `Макс. срок готовности`,
        [Locale.Am]: `Առավ. պատրաստության ժամկետ`,
        [Locale.En]: `Max. time of readiness`,
        [Locale.Pt]: 'Máx. tempo de prontidão',
        [Locale.Ge]: `Max. time of readiness`,
    },
    refreshResult: {
        [Locale.Ru]: `Обновить результаты записи`,
        [Locale.Am]: `Թարմացնել գրառման արդյունքները`,
        [Locale.En]: `Refresh entry results`,
        [Locale.Pt]: 'Atualizar resultados de entrada',
        [Locale.Ge]: `Refresh entry results`,
    },
    barcodeNumbers: {
        [Locale.Ru]: `Номера баркодов`,
        [Locale.Am]: `Շտրիխկոդերի համարներ`,
        [Locale.En]: `Barcode numbers`,
        [Locale.Pt]: 'Números de código de barras',
        [Locale.Ge]: `Barcode numbers`,
    },
    patientFullName: {
        [Locale.Ru]: `Ф.И.О. Пациента`,
        [Locale.Am]: `Պացիենտի Ա.Ա.Հ.`,
        [Locale.En]: `Full name of the patient`,
        [Locale.Pt]: 'Nome completo do paciente',
        [Locale.Ge]: `Full name of the patient`,
    },
    labReqParamsText: {
        [Locale.Ru]: `Обязательный параметры: лаборатория, услуга, лабораторный код.`,
        [Locale.Am]: `Պարտադիր պարամետրեր՝ լաբորատորիա, ծառայություն, լաբորատոր կոդ։`,
        [Locale.En]: `Required parameters: laboratory, service, laboratory code.`,
        [Locale.Pt]: 'Parâmetros necessários: laboratório, serviço, código do laboratório.',
        [Locale.Ge]: `Required parameters: laboratory, service, laboratory code.`,
    },
    diuresis: {
        [Locale.Ru]: `Диурез`,
        [Locale.Am]: `Դիուրեզ`,
        [Locale.En]: `Diuresis`,
        [Locale.Pt]: 'Diurese',
        [Locale.Ge]: `Diuresis`,
    },
    height: {
        [Locale.Ru]: `Рост`,
        [Locale.Am]: `Հասակ`,
        [Locale.En]: `Height`,
        [Locale.Pt]: 'Altura',
        [Locale.Ge]: `Height`,
    },
    weight: {
        [Locale.Ru]: `Вес`,
        [Locale.Am]: `Քաշ`,
        [Locale.En]: `Weight`,
        [Locale.Pt]: 'Peso',
        [Locale.Ge]: `Weight`,
    },
    medicines: {
        [Locale.Ru]: `Лекарства`,
        [Locale.Am]: `Դեղեր`,
        [Locale.En]: `Medicines`,
        [Locale.Pt]: 'Medicação',
        [Locale.Ge]: `Medicines`,
    },
    menstruation: {
        [Locale.Ru]: `Менструация`,
        [Locale.Am]: `Դաշտան`,
        [Locale.En]: `Menstruation`,
        [Locale.Pt]: 'Menstruação',
        [Locale.Ge]: `Menstruation`,
    },
    pregnancy: {
        [Locale.Ru]: `Беременность`,
        [Locale.Am]: `Հղիություն`,
        [Locale.En]: `Pregnancy`,
        [Locale.Pt]: 'Gravidez',
        [Locale.Ge]: `Pregnancy`,
    },
    locationText: {
        [Locale.Ru]: `Локализация из которой произвели взятие`,
        [Locale.Am]: `Տեղակայում, որտեղից կատարվել է վերցնումը`,
        [Locale.En]: `The location from which the sample was taken`,
        [Locale.Pt]: 'O local de onde a amostra foi retirada',
        [Locale.Ge]: `The location from which the sample was taken`,
    },
    countFragmentText: {
        [Locale.Ru]: `Количество фрагментов биоматериала в контейнере`,
        [Locale.Am]: `Կենսանյութի բեկորների քանակը տարայում`,
        [Locale.En]: `Number of biomaterial fragments in a container`,
        [Locale.Pt]: 'Número de fragmentos de biomateriais em um recipiente',
        [Locale.Ge]: `Number of biomaterial fragments in a container`,
    },
    pathologicalText: {
        [Locale.Ru]: `Характер патологического процесса`,
        [Locale.Am]: `Ախտաբանական պրոցեսի բնույթ`,
        [Locale.En]: `The nature of the pathological process`,
        [Locale.Pt]: 'A natureza do processo patológico',
        [Locale.Ge]: `The nature of the pathological process`,
    },
    marking: {
        [Locale.Ru]: `Маркировка`,
        [Locale.Am]: `Մարկավորում`,
        [Locale.En]: `Marking`,
        [Locale.Pt]: 'Marcação',
        [Locale.Ge]: `Marking`,
    },
    pickUpTime: {
        [Locale.Ru]: `Время забора`,
        [Locale.Am]: `Վերցնելու ժամ`,
        [Locale.En]: `Pick up time`,
        [Locale.Pt]: 'Hora de pegar',
        [Locale.Ge]: `Pick up time`,
    },
    bioCodes: {
        [Locale.Ru]: `Био коды`,
        [Locale.Am]: `Կենսակոդեր`,
        [Locale.En]: `Bio codes`,
        [Locale.Pt]: 'códigos biológicos',
        [Locale.Ge]: `Bio codes`,
    },
    editingPrice: {
        [Locale.Ru]: `Редактирование цены`,
        [Locale.Am]: `Գնի խմբագրում`,
        [Locale.En]: `Editing price`,
        [Locale.Pt]: 'Preço de edição',
        [Locale.Ge]: `Editing price`,
    },
    labCode: {
        [Locale.Ru]: `Лаб код`,
        [Locale.Am]: `Լաբ. կոդ`,
        [Locale.En]: `Lab code`,
        [Locale.Pt]: 'Código do laboratório',
        [Locale.Ge]: `Lab code`,
    },
    priceCreation: {
        [Locale.Ru]: `Создание цены`,
        [Locale.Am]: `Գնի ստեղծում`,
        [Locale.En]: `Price creation`,
        [Locale.Pt]: 'Criação de preço',
        [Locale.Ge]: `Price creation`,
    },
    unknownIntegrationType: {
        [Locale.Ru]: `Неизвестный тип интеграции`,
        [Locale.Am]: `Ինտեգրացիայի անհայտ տեսակ`,
        [Locale.En]: `Unknown integration type`,
        [Locale.Pt]: 'Tipo de integração desconhecido',
        [Locale.Ge]: `Unknown integration type`,
    },
    organizationCode: {
        [Locale.Ru]: `Код организации`,
        [Locale.Am]: `Կազմակերպության կոդ`,
        [Locale.En]: `Organization code`,
        [Locale.Pt]: 'Código da organização',
        [Locale.Ge]: `Organization code`,
    },
    changeLaboratory: {
        [Locale.Ru]: `Изменить лабораторию`,
        [Locale.Am]: `Փոփոխել լաբորատորիան`,
        [Locale.En]: `Change laboratory`,
        [Locale.Pt]: 'Alterar laboratório',
        [Locale.Ge]: `Change laboratory`,
    },
    nameInLab: {
        [Locale.Ru]: `Название в лаборатории`,
        [Locale.Am]: `Անվանումը լաբորատորիայում`,
        [Locale.En]: `Name in the laboratory`,
        [Locale.Pt]: 'Nome no laboratório',
        [Locale.Ge]: `Name in the laboratory`,
    },
    laboratoryComment: {
        [Locale.Ru]: `Дополнительная информация`,
        [Locale.Am]: `Լրացուցիչ տեղեկություն`,
        [Locale.En]: `Additional information`,
        [Locale.Pt]: 'Informações adicionais',
        [Locale.Ge]: `Additional information`,
    },
    bioType: {
        [Locale.Ru]: `Тип биоматериала`,
        [Locale.Am]: `Կենսանյութի տեսակ`,
        [Locale.En]: `Type of biomaterial`,
        [Locale.Pt]: 'Tipo de biomaterial',
        [Locale.Ge]: `Type of biomaterial`,
    },
    questionnaire: {
        [Locale.Ru]: `Опросник`,
        [Locale.Am]: `Հարցաթերթիկ`,
        [Locale.En]: `Questionnaire`,
        [Locale.Pt]: 'Questionário',
        [Locale.Ge]: `Questionnaire`,
    },
    laboratory: {
        [Locale.Ru]: 'Лаборатория',
        [Locale.Am]: 'Լաբորատորիա',
        [Locale.En]: 'Laboratory',
        [Locale.Pt]: 'Laboratório',
        [Locale.Ge]: 'ლაბორატორია',
    },
    laboratoryCode: {
        [Locale.Ru]: 'Лабораторный код',
        [Locale.Am]: 'Լաբորատոր կոդ',
        [Locale.En]: 'Laboratory Code',
        [Locale.Pt]: 'Código do Laboratório',
        [Locale.Ge]: 'ლაბორატორიული კოდი',
    },
    bioCode: {
        [Locale.Ru]: 'Био код',
        [Locale.Am]: 'Կենսակոդ',
        [Locale.En]: 'Bio code',
        [Locale.Pt]: 'Código biológico',
        [Locale.Ge]: 'ბიო კოდი',
    },
    minValue: {
        [Locale.Ru]: `Мин. значение`,
        [Locale.Am]: `Նվազ. արժեք`,
        [Locale.En]: `Min. value`,
        [Locale.Pt]: 'Min. valor',
        [Locale.Ge]: `Min. value`,
    },
    maxValue: {
        [Locale.Ru]: `Макс. значение`,
        [Locale.Am]: `Առավ. արժեք`,
        [Locale.En]: `Max value`,
        [Locale.Pt]: 'Valor máximo',
        [Locale.Ge]: `Max value`,
    },
    maxLengthShort: {
        [Locale.Ru]: `Макс. длина`,
        [Locale.Am]: `Առավ. երկարություն`,
        [Locale.En]: `Max length`,
        [Locale.Pt]: 'Comprimento máximo',
        [Locale.Ge]: `Max length`,
    },
    forceCancel: {
        [Locale.Ru]: `Отменить принудительно`,
        [Locale.Am]: `Չեղարկել հարկադրաբար`,
        [Locale.En]: `Force cancel`,
        [Locale.Pt]: 'Forçar cancelamento',
        [Locale.Ge]: `Force cancel`,
    },
    errorOnCancelOrder: {
        [Locale.Ru]: `Ошбика при отмене ордера`,
        [Locale.Am]: `Օրդերի չեղարկման սխալ`,
        [Locale.En]: `Error while canceling order`,
        [Locale.Pt]: 'Erro ao cancelar pedido',
        [Locale.Ge]: `Error while canceling order`,
    },
    labDidNotAcceptOrder: {
        [Locale.Ru]: `Лаборатория не приняла запрос`,
        [Locale.Am]: `Լաբորատորիան չի ընդունել հարցումը`,
        [Locale.En]: `The lab did not accept the request.`,
        [Locale.Pt]: 'O laboratório não aceitou a solicitação.',
        [Locale.Ge]: `The lab did not accept the request.`,
    },
    takeVeinBlood: {
        [Locale.Ru]: `Взятие крови из вены`,
        [Locale.Am]: `Արյան վերցնում երակից`,
        [Locale.En]: `Taking blood from a vein`,
        [Locale.Pt]: 'Tirando sangue de uma veia',
        [Locale.Ge]: `Taking blood from a vein`,
    },
    takeFingerBlood: {
        [Locale.Ru]: `Взятие крови из пальца`,
        [Locale.Am]: `Արյան վերցնում մատից`,
        [Locale.En]: `Taking blood from a finger`,
        [Locale.Pt]: 'Tirando sangue de um dedo',
        [Locale.Ge]: `Taking blood from a finger`,
    },
    takeArteryBlood: {
        [Locale.Ru]: `Взятие крови из артерии`,
        [Locale.Am]: `Արյան վերցնում զարկերակից`,
        [Locale.En]: `Taking blood from an artery`,
        [Locale.Pt]: 'Tirando sangue de uma artéria',
        [Locale.Ge]: `Taking blood from an artery`,
    },
    externalOrderCanselText: {
        [Locale.Ru]: `Заказы во внешних лабораториях будут отменены`,
        [Locale.Am]: `Արտաքին լաբորատորիաներում պատվերները կչեղարկվեն`,
        [Locale.En]: `Orders from external labs will be cancelled`,
        [Locale.Pt]: 'Pedidos de laboratórios externos serão cancelados',
        [Locale.Ge]: `Orders from external labs will be cancelled`,
    },
    cancelOrders: {
        [Locale.Ru]: `Отменить заказы`,
        [Locale.Am]: `Չեղարկել պատվերները`,
        [Locale.En]: `Cancel orders`,
        [Locale.Pt]: 'Cancelar pedidos',
        [Locale.Ge]: `Cancel orders`,
    },
    cancelOrder: {
        [Locale.Ru]: `Отменить заказ`,
        [Locale.Am]: `Չեղարկել պատվերը`,
        [Locale.En]: `Cancel order`,
        [Locale.Pt]: 'Cancelar pedido',
        [Locale.Ge]: `Cancel order`,
    },
    printAll: {
        [Locale.Ru]: `Напечатать все`,
        [Locale.Am]: `Տպել բոլորը`,
        [Locale.En]: `Print all`,
        [Locale.Pt]: 'Imprimir tudo',
        [Locale.Ge]: `Print all`,
    },
    selectLabClinicText: {
        [Locale.Ru]: `Пожалуйста выберите клинику, в которой вы принимаете анализ.`,
        [Locale.Am]: `Խնդրում ենք ընտրել կլինիկան, որտեղ դուք ընդունում եք անալիզը։`,
        [Locale.En]: `Please select the clinic where you take the test.`,
        [Locale.Pt]: 'Selecione a clínica onde você fará o teste.',
        [Locale.Ge]: `Please select the clinic where you take the test.`,
    },
    vendorCode: {
        [Locale.Ru]: `Артикул`,
        [Locale.Am]: `Արտիկուլ`,
        [Locale.En]: `Vendor code`,
        [Locale.Pt]: 'Código do fornecedor',
        [Locale.Ge]: `Vendor code`,
    },
    downloadLabServ: {
        [Locale.Ru]: `Загрузить лабораторные услуги`,
        [Locale.Am]: `Վերբեռնել լաբորատոր ծառայությունները`,
        [Locale.En]: `Download Lab Services`,
        [Locale.Pt]: 'Baixar serviços de laboratório',
        [Locale.Ge]: `Download Lab Services`,
    },
    dividedBy: {
        [Locale.Ru]: `разделяются через`,
        [Locale.Am]: `բաժանվում են`,
        [Locale.En]: `are divided by`,
        [Locale.Pt]: 'são divididos por',
        [Locale.Ge]: `are divided by`,
    },
    downloadLabServicePrice: {
        [Locale.Ru]: `Загрузить цены лабораторных услуг`,
        [Locale.Am]: `Վերբեռնել լաբորատոր ծառայությունների գները`,
        [Locale.En]: `Download prices for laboratory services`,
        [Locale.Pt]: 'Baixe preços para serviços de laboratório',
        [Locale.Ge]: `Download prices for laboratory services`,
    },
    orderBarCode: {
        [Locale.Ru]: `Номера баркодов заказа`,
        [Locale.Am]: `Պատվերի շտրիխկոդերի համարներ`,
        [Locale.En]: `Order barcode numbers`,
        [Locale.Pt]: 'Encomendar números de código de barras',
        [Locale.Ge]: `Order barcode numbers`,
    },
    sendDeGiniRep: {
        [Locale.Ru]: `Отправка реестров Де Жени`,
        [Locale.Am]: `Դե Ժենի ռեեստրների ուղարկում`,
        [Locale.En]: `Sending the registers to De Geni`,
        [Locale.Pt]: 'Envio dos registros para De Geni',
        [Locale.Ge]: `Sending the registers to De Geni`,
    },
    registersNotSent: {
        [Locale.Ru]: `Реестры не отправлены`,
        [Locale.Am]: `Ռեեստրները չեն ուղարկվել`,
        [Locale.En]: `Registers not sent`,
        [Locale.Pt]: 'Registros não enviados',
        [Locale.Ge]: `Registers not sent`,
    },
    errorHappenedTryAgain: {
        [Locale.Ru]: `Возникла ошибка при обновлении. Попробуейте снова`,
        [Locale.Am]: `Թարմացնելիս առաջացել է սխալ։ Փորձեք կրկին`,
        [Locale.En]: `An error occurred while updating. Please try again.`,
        [Locale.Pt]: 'Ocorreu um erro durante a atualização. Por favor, tente novamente.',
        [Locale.Ge]: `An error occurred while updating. Please try again.`,
    },
    errorOnSatusChange: {
        [Locale.Ru]: `Ошибка изменения статуса`,
        [Locale.Am]: `Կարգավիճակի փոփոխման սխալ`,
        [Locale.En]: `Status change error`,
        [Locale.Pt]: 'Erro de alteração de status',
        [Locale.Ge]: `Status change error`,
    },
    errorOnOrderCanceling: {
        [Locale.Ru]: `Произошла ошибка при отмене заказа.`,
        [Locale.Am]: `Պատվերի չեղարկման ժամանակ առաջացել է սխալ։`,
        [Locale.En]: `There was an error canceling your order.`,
        [Locale.Pt]: 'Ocorreu um erro ao cancelar seu pedido.',
        [Locale.Ge]: `There was an error canceling your order.`,
    },
    errorEpisodeNamesCreatingHints: {
        [Locale.Ru]: `Ошибка при создании вариантов названия эпизода.`,
        [Locale.Am]: `Էպիզոդի անվանման տարբերակների ստեղծման սխալ։`,
        [Locale.En]: `Error occurred while generating episode name suggestions.`,
        [Locale.Pt]: 'Ocorreu um erro ao gerar sugestões de nomes de episódios.',
        [Locale.Ge]: `Error occurred while generating episode name suggestions.`,
    },
    labelForPrinting: {
        [Locale.Ru]: `Этикета для печати`,
        [Locale.Am]: `Պիտակ տպելու համար`,
        [Locale.En]: `Label for printing`,
        [Locale.Pt]: 'Etiqueta para impressão',
        [Locale.Ge]: `Label for printing`,
    },
    noTubeForPrint: {
        [Locale.Ru]: `Нет пробирок для печати`,
        [Locale.Am]: `Տպելու համար փորձանոթներ չկան`,
        [Locale.En]: `No test tubes for printing`,
        [Locale.Pt]: 'Sem tubos de ensaio para impressão',
        [Locale.Ge]: `No test tubes for printing`,
    },
    printAllBarcodes: {
        [Locale.Ru]: `Напечатать все штрихкоды`,
        [Locale.Am]: `Տպել բոլոր շտրիխկոդերը`,
        [Locale.En]: `Print all barcodes`,
        [Locale.Pt]: 'Imprimir todos os códigos de barras',
        [Locale.Ge]: `Print all barcodes`,
    },
    addBloodServices: {
        [Locale.Ru]: `Добавить услуги по взятию крови`,
        [Locale.Am]: `Ավելացնել արյան վերցնման ծառայություններ`,
        [Locale.En]: `Add blood collection services`,
        [Locale.Pt]: 'Adicionar serviços de colheita de sangue',
        [Locale.Ge]: `Add blood collection services`,
    }
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
};
